import React, { useEffect, useState } from "react";
import { CustomModal } from "../../components/customModal";
import { NativeModules, Platform, StatusBar, Text, View } from "react-native";
import { useCssStyle } from "../../customHook/getCssStyle";
import { AdminVerification } from "./adminVerification";
import { useDispatch, useSelector } from "react-redux";
import { setClientId, setConnectorIP, setInitAppLogout, setRenderAdminModal, setServiceStatus } from "../../Redux/Reducers/appConfigReducer";
import { useTranslation } from "react-i18next";
import { DeviceRegistration } from "./deviceRegistration";
import { RoomSelection } from "./roomSelection";
import { current_client_config, currentIP } from "../../config/Constant";
import AsyncStorage from "@react-native-async-storage/async-storage";
import KeyboardAvoidingWrapper from "../../components/keyboardAvoidingWrapper";


const { StatusBarManager } = NativeModules;


export const AdminPanel = () => {

    const getStyles = useCssStyle();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const [statusBarHeight, setStatusBarHeight] = useState(0);


    const { serviceStatus } = useSelector(state => state.appConfigSlice);

    const [isVerified, setIsVerified] = React.useState(false);

    const handleUserVerified = () => {
        setIsVerified(true);
    }


    const [serverConfigInfo, setServerConfigInfo] = React.useState({
        deviceName: null,
        serverIp: currentIP,
        clientConfig: current_client_config
    })

    const [selectedRoom, setSelectedRoom] = React.useState(null);

    const [proceedRoomSelection, setProceedRoomSelection] = React.useState(false);

    const handleCloseModal = () => {
        dispatch(setRenderAdminModal(false));
    }

    const handleRegisterDevice = async () => {

        if(selectedRoom){
            await AsyncStorage.setItem("roomID", JSON.stringify(selectedRoom));
        } else {
            await AsyncStorage.removeItem("roomID");   
        }

        serverConfigInfo.deviceName && await AsyncStorage.setItem("deviceName", serverConfigInfo.deviceName);

        await AsyncStorage.setItem("connectorIP_inroomapp", serverConfigInfo.serverIp);
        await AsyncStorage.setItem("clientId_inroomapp", serverConfigInfo.clientConfig);

        handleCloseModal();
        dispatch(setConnectorIP(serverConfigInfo.serverIp));
        dispatch(setClientId(serverConfigInfo.clientConfig));

        if(serviceStatus?.hasError){
            dispatch(setServiceStatus({ hasError: false }))
        } else {
            dispatch(setInitAppLogout(true));
        }
    }

    const getStatusBarHeight = () => {
        if (Platform.OS === 'ios') {
          StatusBarManager.getHeight((height) => setStatusBarHeight(height.height || 0));
        } else {
          setStatusBarHeight(StatusBar.currentHeight || 0);
        }
    };


    useEffect(() => {
        getStatusBarHeight();
    })

    return (
        <CustomModal onRequestClose={handleCloseModal} >
            <KeyboardAvoidingWrapper style={getStyles(['modalOverlay'])} keyboardVerticalOffset={0}>
            <View style={getStyles([ { marginTop: Platform.OS === 'ios' ? statusBarHeight : statusBarHeight }, 'adminPanelModalContainer'])}>
                <Text style={getStyles(['adminPanelModalTitle'])}>{t('admin_panel.heading')}</Text>
                {!isVerified ?
                    <AdminVerification handleNext={handleUserVerified} handleGoHome={handleCloseModal} />
                    : proceedRoomSelection ?
                        <RoomSelection handleGoHome={handleCloseModal} serverConfigInfo={serverConfigInfo} selectedRoom={selectedRoom} setSelectedRoom={setSelectedRoom} handleNext={handleRegisterDevice} />
                        :
                        <DeviceRegistration handleGoHome={handleCloseModal} serverConfigInfo={serverConfigInfo} setServerConfigInfo={setServerConfigInfo}  handleNext={() => setProceedRoomSelection(true)} />
                }
            </View>
            </KeyboardAvoidingWrapper>
        </CustomModal>
    )
}